import { SavingRateTrendTile } from "../../components/dashboard/SavingRateTrendTile.js";
import { ShockinglySimpleMathTable } from "../../components/dashboard/ShockinglySimpleMathTable.js";
import { SuggestedPromptsTile } from "../../components/SuggestedPromptsTile.js";
import { PAGE_PROMPTS } from "../../lib/data/page-prompts.js";
import { useDocumentTitle } from "../../lib/util/use-document-title.js";
import { FireSubPageLayout } from "./_layout.js";

/**
 * /fire/saving-rate — Phase 13.5 extraction.
 *
 * Trailing-12 saving-rate trend (12-month sparkline + status pill +
 * MoM/YoY deltas) anchored by the Mr Money Mustache "Shockingly Simple
 * Math" table that explains why even small saving-rate moves crush
 * years off the FI horizon.
 */
export function FireSavingRatePage() {
  useDocumentTitle("FIRE — Saving rate");
  const today = new Date().toISOString().slice(0, 10);
  return (
    <FireSubPageLayout
      title="Saving rate trend"
      sub="Where your trailing-12 saving rate sits today, and the math that turns small saving-rate moves into years off your FI date."
    >
      <SavingRateTrendTile today={today} />
      <ShockinglySimpleMathTable />
      <SuggestedPromptsTile prompts={PAGE_PROMPTS.fireSavingRate} />
    </FireSubPageLayout>
  );
}
